module.exports = __webpack_public_path__ + "static/media/function_introduction.8628a072.png";